import './App.css';
import React, { useEffect } from 'react';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ProductsSection from './components/ProductsSection';
import AboutSection from './components/AboutSection';
import StatisticsBar from './components/StatisticsBar';
import ServicesSection from './components/ServicesSection';
import PartnersSection from './components/PartnersSection';
import TestimonialsNewsSection from './components/TestimonialsNewsSection';
import Footer from './components/Footer';
import FaqPage from './pages/FaqPage';
import AllProducts from "./pages/AllProducts";
import ContactPage from './pages/ContactPage';
import EProfilePage from './pages/EProfilePage';
import SolutionsIndexPage from './pages/SolutionsIndexPage';
import SolutionDetailPage from './pages/SolutionDetailPage';
import ComingSoonPage from './pages/ComingSoonPage';

function App() {
  const path = typeof window !== 'undefined' && window.location ? window.location.pathname : '/';
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (path !== '/') return;
    const { hash } = window.location;
    if (!hash) return;
    const id = hash.replace('#', '');
    const headerHeight = 80;
    const easeInOutQuad = (t, b, c, d) => {
      let time = t / (d / 2);
      if (time < 1) return (c / 2) * time * time + b;
      time--;
      return (-c / 2) * (time * (time - 2) - 1) + b;
    };
    const smoothScrollToY = (targetY, duration = 1500) => {
      const startY = window.pageYOffset;
      const distance = targetY - startY;
      let startTime = null;
      const step = (currentTime) => {
        if (startTime === null) startTime = currentTime;
        const elapsed = currentTime - startTime;
        const nextY = easeInOutQuad(elapsed, startY, distance, duration);
        window.scrollTo(0, nextY);
        if (elapsed < duration) {
          requestAnimationFrame(step);
        } else {
          window.scrollTo(0, targetY);
        }
      };
      requestAnimationFrame(step);
    };
    const tryScroll = () => {
      const el = document.getElementById(id);
      if (el) {
        const rect = el.getBoundingClientRect();
        const absoluteY = rect.top + window.pageYOffset - headerHeight;
        smoothScrollToY(Math.max(absoluteY, 0));
        return true;
      }
      return false;
    };
    if (!tryScroll()) {
      setTimeout(tryScroll, 100);
      setTimeout(tryScroll, 300);
    }
  }, [path]);
  const isFaq = path === '/faq/';
  const isAllProducts = path === '/allproducts/';
  const isContact = path === '/contact-us/';
  const isECatalog = path === '/e-catalog/';
  const isSolutions = path.startsWith('/solutions/');
  const isComingSoon = path === '/coming-soon/';
  
  if (isFaq) {
    return (
      <div className="App">
        <Header />
        <FaqPage />
        <Footer />
        
      </div>
    );
  }
    if (isAllProducts ) {
    return (
      <div className="App">
        <Header />
        <AllProducts />
        <Footer />
        
      </div>
    );
  }

  if (isECatalog) {
    return (
      <div className="App">
        <Header />
        <EProfilePage />
        <Footer />
       
      </div>
    );
  }

  if (isSolutions) {
    const slug = path.replace(/^\/?solutions\/?/, '').replace(/\/$/, '');
    return (
      <div className="App">
        <Header />
        {slug ? <SolutionDetailPage /> : <SolutionsIndexPage />}
        <Footer />
   
      </div>
    );
  }

  if (isComingSoon) {
    return (
      <div className="App">
        <Header />
        <ComingSoonPage />
        <Footer />
      </div>
    );
  }

  if (isContact) {
    return (
      <div className="App">
        <Header />
        <ContactPage />
        <Footer />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <HeroSection />
      <ProductsSection />
      <AboutSection />
      <StatisticsBar />
      <ServicesSection />
      <PartnersSection />
      <TestimonialsNewsSection />
      <Footer />
      
    </div>
  );
}

export default App;
